import {useMutation, useQueryClient} from "@tanstack/react-query";
import {EventAPI} from "../../services/network/event-api";
import {EVENT_ENDPOINTS} from "../../services/network/endpoints";
import {IEvent, IEventCreate} from "../../services/models/event";
import {toast} from "react-toastify";

export function useDeleteEvent() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: [EVENT_ENDPOINTS.DELETE],
        mutationFn: (id:string) => EventAPI.delete(id),
        onError() {
            toast.error("Ошибка удаления события");
        },
        onSuccess: () => {
            // Инвалидируем кэш списка событий, чтобы обновить их после создания нового
            queryClient.invalidateQueries({ queryKey: [EVENT_ENDPOINTS.FETCH_EVENTS] });
            toast.success("Событие успешно удалено");
        }
    });
}
